import { render, staticRenderFns } from "./GItemSkuContent.vue?vue&type=template&id=3de5eaad&scoped=true&"
import script from "./GItemSkuContent.vue?vue&type=script&lang=ts&"
export * from "./GItemSkuContent.vue?vue&type=script&lang=ts&"
import style0 from "./GItemSkuContent.vue?vue&type=style&index=0&id=3de5eaad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5eaad",
  null
  
)

export default component.exports